export default "__VITE_ASSET__Bnyttxyr__"